import { PublicAccessInfoDto } from '../generated';
import { User } from '../model/User';
import { parsePhoneNumber } from './phoneNumber.parser';
import { parseRequestType } from './requestType.parser';

export const parseUser = (data: PublicAccessInfoDto): User => {
  return {
    email: data.email ?? undefined,
    phone: parsePhoneNumber(data.phoneNumberDto),
    requestType: parseRequestType(data.formType)
  };
};
